import moment from 'moment-timezone';
import _invert from 'lodash/invert';
import { TIME_STAMP } from './helper.constants';
export const DATE_TIME_FORMATS = {
  ABBREVIATED_MONTH_COMMA_FULL_YEAR: 'MMM, YYYY',
  HOUR_MIN: 'LT',
  HOUR_MIN_SEC: 'LTS',
  NUMERIC_DATE: 'L',
  ABBREVIATED_NUMERIC_DATE: 'l',
  DATE_ALPHA_MONTH: 'LL',
  ABBREVIATED_DATE_ALPHA_MONTH: 'll',
  DATE_ALPHA_MONTH_WITH_TIME: 'LLL',
  ABBREVIATED_DATE_ALPHA_MONTH_WITH_TIME: 'lll',
  DATE_ALPHA_WITH_DAY: 'LLLL',
  ABBREVIATED_DATE_ALPHA_WITH_DAY: 'llll',
  NATIVE_DATE_FORMAT: 'DD-MM-YYYY',
  ABBREVIATED_BASE_DATE_FORMAT: 'DD/MM/YY',
  BASE_DATE_FORMAT_US: 'MM/DD/YYYY',
  ABBREVIATED_BASE_DATE_FORMAT_US: 'MM/DD/YY',
  DATE_WITH_DAY: 'ddd ll',
  DATE_WITH_FULL_DAY: 'dddd ll',
  DATE_WITH_TIME: 'd-MMM-YYYY h:m:s A',
  ISO_8601_DATE: 'YYYY-MM-DD',
  TIME_STAMP: 'x',
  HOUR_MIN_FORMAT: 'hh:mm A',
  HOUR_MIN_FORMAT_WITHOUT_SUFFIX: 'hh:mm',
  TWENTY_FOUR_HOUR_MIN: 'HH:mm',
  HOUR_MIN_SEC_FORMAT: 'HH:mm:ss A',
  TWENTY_FOUR_HOUR_MIN_SEC_FORMAT_WITHOUT_SUFFIX: 'HH:mm:ss',
  DEAL_REBATE_EST: 'YYYY-MM-DD hh:mm:ss -0500',
  MONTH_YEAR: 'MM/YYYY',
  DOWNLOADABLE_DATE_TIME_FORMAT: 'DD-MMM-YYYY',
  MONTH_YEAR_FORMAT: 'MMM YYYY',
  FULL_MONTH_YEAR_FORMAT: 'MMMM YYYY',
  EXPORT_EXCEL_FORMAT: 'YYYYMMDD',
  YEAR_MONTH: 'YYYY_MM',
  YEAR: 'YYYY',
  MONTH: 'MMMM',
  MONTH_DAY: 'MMM D',
  ABBREVIATED_MONTH_WITH_TIME: 'MMM DD, LT',
  ABBREVIATED_MONTH_DATE_YEAR: 'MMM DD, YYYY',
  FULL_MONTH_DATE_YEAR: 'MMMM DD, YYYY',
  YEAR_MONTH_DATE_TIME: 'DD MMMM, YYYY [at] h:m A',
  ABBREVIATED_MONTH_DAY_COMMA_FULL_YEAR: 'MMM DD, YYYY',
  MONTH_DATE_YEAR_HYPHEN: 'MMM DD, YYYY | hh:mm a',
  DAY_MONTH_DATE_YEAR_TIME: 'ddd, MMM DD, YYYY | hh:mm a',
  DAY_MONTH_DATE_YEAR_WITH_TIME: 'ddd MMM DD, YYYY | hh:mmA',
  DATE_MONTH_WITH_DAY: 'ddd, MMM DD',
  HOUR_MIN_SEC_WITH_LETTER: 'h[h] mm[m] ss[s]',
  ABBREVIATED_BASE_DATE_FORMAT_US_WITH_TIME: 'MM/DD/YY | hh:mm A',
  TIME_WITH_DATE_FORMAT: 'hh:mm A | MMM DD, YYYY',
  DAY_DATE_MONTH_YEAR: 'dddd - DD MMMM, YYYY',
  ABBREVIATED_DAY_NAME: 'dd',
  FULL_DAY_NAME: 'dddd',
  DAY_MONTH_DATE_WITH_TIME: 'ddd MMM DD | hh:mmA',
  DOWNLOADABLE_DATE_FORMAT_WITH_TIME: 'DD-MMM-YYYY hh:mm:ss A',
  ABBREVIATED_DATE_MONTH_YEAR_WITH_TIME: 'Do MMM, YYYY | hh:mm A',
  SHORT_WEEK_WITH_DAY: 'ddd D',
  SHORT_WEEK: 'ddd',
  SHORT_HOUR: 'h',
  HOUR_MIN_SHORT: 'ha',
  MONTH_DAY_FULL: 'MMMM DD',
  DAY_YEAR: 'DD, YYYY',
  HOUR_MIN_WITHOUT_MERIDIAN: 'h:mm',
  HOUR_MIN_WITH_MERIDIAN: 'h:mma',
  DATE_MONTH_YEAR: 'DD MMM YYYY',
  DAY_MONTH_DATE_YEAR: 'ddd, MMM DD, YYYY',
  DATE_WEEK_YEAR: 'ww - YYYY',
  QUARTER_YEAR: '[Q]Q - YYYY',
  DATE_ORDINAL_DAYS_ALPHA_MONTH_YEAR: 'Do MMMM, YYYY',
  MONTH_DATE_YEAR_TIME: 'MMM DD, YYYY | hh:mm A',
  MONTH_DATE_TIME: 'MMM DD HH:mm A',
  DATE_ORDINAL_SHORT_DAY_WITH_MONTH: 'ddd, Do MMM',
  DAY_OF_MONTH: 'D',
  DATE_MONTH_YEAR_WITH_TIME_IN_24HR_FORMAT: 'DD MMM YYYY, HH:mm',
  ABBREVIATED_DATE_ALPHA_MONTH_YEAR_WITH_TIME: 'll | LT',
  ABBREVIATED_MONTH_DATE: 'MM/DD',
  ABBREVIATED_MONTH: 'MMM',
  MONTH_HALF_YEAR: 'MMM YY',
  ABBREVIATED_DATE_MONTH_YEAR_WITH_TIME_MERIDIAN: 'D MMM YYYY, h:mm a',
  ABBREVIATED_MONTH_DATE_YEAR_WITH_TIME_MERIDIAN: 'MMM D YYYY, h:mm a',
  MONTH_OF_YEAR: 'M',
  HOUR_MIN_SEC_12HRS: 'hh:mm:ss A',
  MONTH_DATE_YEAR_TIME_12HR_FORMAT: 'MMMM D, YYYY hh:mm A',
  // OCT 22, 2021 02:34PM
  DATE_ORDINAL_MONTH_YEAR_WITH_TIME: 'Do MMM YYYY, hh:mm A',
  YEAR_MONETH_DATE_TIME: 'YYYY-DD-MM_HHmm'
};
const MOMENT_VS_TEKION_FORMAT = _invert(DATE_TIME_FORMATS);
export const isValidDateTimeFormat = format => MOMENT_VS_TEKION_FORMAT[format];

/**
 * Duration between two time in minutes
 * @param  {[type]} end Timestamp
 * @param  {[type]} start Timestamp
 * @return {[type]}  Duration in minutes
 */
export const getDifferenceAsMinutes = (end, start) => {
  const duration = moment.duration(moment(end).diff(moment(start)));
  return Math.round(duration.asMinutes());
};

/**
 * Duration between two time in hours
 * @param  {[type]} end Timestamp
 * @param  {[type]} start Timestamp
 * @return {[type]}  Duration in hours
 */
export const getDifferenceAsHours = (end, start) => {
  const duration = moment.duration(moment(end).diff(moment(start)));
  return duration.asHours();
};

/**
 * Format given timestamp according to the format passed
 * @param  {[type]} epochOrMomentObject Timestamp
 * @param  {[type]} format   One of the format mentioned in DATE_TIME_FORMATS
 * @param  {[type]} timezone Timezone in which to format the date
 * @return {[type]}          Formatted date/time
 */
export const getFormattedDateTime = (epochOrMomentObject, format, timezone) => {
  if (!isValidDateTimeFormat(format)) {
    throw __('Invalid date format :- {{format}}', {
      format
    });
  }
  const momentObject = moment(epochOrMomentObject);
  const momentToFormat = timezone ? momentObject.tz(timezone) : momentObject;
  return momentToFormat.format(format);
};
export const commentTimeStamp = timestamp => {
  if (!timestamp) {
    return '';
  }
  const today = moment().local();
  const minutesDiff = getDifferenceAsMinutes(today, timestamp);
  // Within Minutes
  if (minutesDiff <= 0) {
    return TIME_STAMP.JUST_NOW;
  }
  if (minutesDiff === 1) {
    return TIME_STAMP.MINUTE_AGO;
  }
  if (minutesDiff < 60) {
    return __('{{minutesDiff}} minutes ago', {
      minutesDiff
    });
  }

  // Within Hours
  const hoursDiff = getDifferenceAsHours(today, timestamp) > 0 ? Math.floor(getDifferenceAsHours(today, timestamp)) : 0;
  if (hoursDiff === 1) {
    return TIME_STAMP.AN_HOUR_AGO;
  }
  if (hoursDiff > 0 && hoursDiff < 24) {
    return __('{{hoursDiff}} hours ago', {
      hoursDiff
    });
  }
  const dateFormat = getFormattedDateTime(timestamp, 'lll');
  return "".concat(dateFormat);
};